
import { notification } from 'antd';

class NotificationPopUp {

    static info(description) {
        this.shownNotification('info', 'Informazione', description, 'antdInfo');
    }

    static success(description) {
        this.shownNotification('success', 'OK', description, 'antdSuccess');
    }

    static warning(description) {
        this.shownNotification('warning', 'Attenzione', description, 'antdWarn');
    }

    static error(description) {
        this.shownNotification('error', 'Errore', description, 'antdError');
    }

    static shownNotification(type, message, description, customClass) {
        notification[type]({
            className: customClass,
            description: description,
            duration: 5, // In seconds
            message: message,
            placement: 'bottomRight'
        });
    }
}

export default NotificationPopUp;
